(function() {
  var collectionHandle = window.collectionHandle;
  var collectionModel = window.collectionModel || collectionHandle;

  // --- ANALYTICS WEBHOOK: paste your Google Apps Script Web App URL here ---
  var ANALYTICS_WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycbztPtmWF8L6FSdRNQR6vceHGBBavLDmHze4uF9jPRS5ja15EEJ1yxnzR89PZcUWTRLBOQ/exec';

  // --- ALL PRODUCTS stored at outer scope so all functions share it ---
  var allProducts = [];
  var filteredProducts = [];
  var displayedResults = 0;
  var resultsPerPage = 24;
  var analyticsTimeout;
  var currentSearchTerm = ''; // the search that's currently on screen, so product clicks can be tied back to it
  var currentSearchId = '';   // unique per search, lets the backend merge a click into the matching search row

  // How long a cached catalog is trusted before we refetch (ms).
  // Ajax storefront data can go stale (new products, inventory changes),
  // so this is a compromise between "instant repeat search" and "fresh data".
  var CACHE_TTL_MS = 15 * 60 * 1000; // 15 minutes
  // v2: cache entries now carry tagHandles (needed for sidebar filters).
  // Bumping the key makes older cached catalogs (without tags) refetch once.
  var CACHE_KEY = 'collectionSearchCache:v2:' + collectionHandle;

  // Descriptions can be long. We still cap this rather than store every
  // character verbatim, since with thousands of products the sessionStorage
  // cache payload adds up — but 400 was cutting off real content (a
  // compatibility note or spec near the bottom of a longer description),
  // causing legitimate matches to be missed. 3000 chars covers the vast
  // majority of real product descriptions in full; if a description is
  // ever longer than that, only the excess past 3000 is left unsearched.
  // (writeCache() already degrades gracefully — skips caching rather than
  // breaking search — if this ever pushes a payload over quota.)
  var MAX_DESC_CHARS = 3000;

  // Optional: if the Liquid sets window.collectionProductsCount, the fill
  // inside the search bar tracks real progress (500 of 1,240 = 40% filled).
  // Without it, a shorter fill slides back and forth instead.
  var TOTAL_PRODUCT_COUNT = parseInt(window.collectionProductsCount, 10) || 0;

  // --- SYNONYM MAP ---
  var SYNONYMS = {
    'light':    ['lamp', 'bulb', 'led', 'lighting', 'headlight', 'taillight', 'beacon'],
    'lamp':     ['light', 'bulb', 'led'],
    'ac':    ['A/C', 'A C', 'air conditioning'],
    'a/c':    ['AC', 'A C', 'air conditioning'],
    'refrigeration': ['ac', 'air conditioning', 'compressor', 'condenser', 'evaporator'],
    'bulb':     ['light', 'lamp', 'led'],
    'led':      ['light', 'lamp', 'bulb'],
    'driveshaft':      ['drive shaft'],
    'drive shaft':      ['driveshaft'],
    'filter':   ['strainer', 'screen', 'purifier'],
    'petcock':   ['butterfly valve', 'fuel valve', 'shut off', 'shutoff'],
    'gauge cluster':   ['instrument cluster', 'instrument'],
    'guage':    ['gauge'],
    'fuel tank cap':   ['fuel cap', 'gas cap', 'filler cap', 'fuel filler cap'],
    'fuelcap':  ['fuel cap', 'fuel tank cap'],
    'strainer': ['filter', 'screen'],
    'belt':     ['strap', 'band', 'drive belt', 'v-belt', 'serpentine'],
    'seal':     ['gasket', 'o-ring', 'oring', 'ring'],
    'hydraulic cylinder':     ['hydraulic ram', 'ram'],
    'seal kit':     ['repair kit', 'repair', 'rebuild kit', 'rebuild'],
    'gasket':   ['seal', 'o-ring', 'oring'],
    'o-ring':   ['o ring', 'oring'],
    'bearing':  ['bushing', 'race'],
    'bushing':  ['bearing', 'sleeve', 'bush'],
    '3-point':  ['3 point', '3pt', 'three point'],
    'hose':     ['tube', 'pipe', 'line', 'tubing'],
    'hoes':     ['hose'],
    'tube':     ['hose', 'pipe', 'line'],
    'pipe':     ['hose', 'tube', 'line'],
    'brake':    ['braking', 'caliper', 'pad', 'rotor', 'drum'],
    'shock':    ['strut', 'damper', 'absorber'],
    'strut':    ['shock', 'damper'],
    'battery':  ['cell', 'accumulator'],
    'switch':   ['toggle', 'relay', 'button'],
    'wire':     ['cable', 'harness', 'wiring', 'lead'],
    'cable':    ['wire', 'harness', 'lead'],
    'mirror':   ['glass', 'reflector'],
    'bumper':   ['guard', 'skid plate'],
    'seat':     ['cushion', 'bench'],
    'tire':     ['tyre', 'wheel'],
    'wheel':    ['rim', 'tire', 'tyre'],
    'rim':      ['wheel'],
    'oil':      ['fluid', 'lubricant', 'lube'],
    'fluid':    ['oil', 'lubricant', 'coolant'],
    'coolant':  ['fluid', 'antifreeze'],
    'antifreeze': ['coolant'],
    'bolt':     ['screw', 'fastener', 'stud'],
    'screw':    ['bolt', 'fastener'],
    'nut':      ['fastener', 'hex'],
    'bracket':  ['mount', 'brace', 'support', 'clamp'],
    'mount':    ['bracket', 'support', 'brace'],
    'clip':     ['clamp', 'retainer', 'snap'],
    'clamp':    ['clip', 'bracket', 'band'],
    'throttle': ['accelerator', 'gas pedal'],
    'pedal':    ['throttle', 'accelerator'],
    'petal':    ['pedal'],
    'handle':   ['grip', 'lever', 'bar'],
    'lever':    ['handle', 'arm'],
    'grip':     ['handle', 'bar'],
    'exhaust':  ['muffler', 'pipe', 'silencer'],
    'muffler':  ['exhaust', 'silencer'],
    'fuel':     ['gas', 'petrol', 'diesel'],
    'tank':     ['reservoir', 'container'],
    'cab':      ['canopy', 'roof', 'enclosure'],
    'cover':    ['cap', 'lid', 'hood', 'guard', 'shield'],
    'guard':    ['shield', 'cover', 'protector', 'bumper'],
    'grill':     ['grille'],
    'grille':    ['grill'],
    'skid':     ['plate', 'guard', 'protector'],
    'driver side':  ['left side', 'left hand', 'lh', 'left'],
    'passenger side': ['right side', 'right hand', 'rh', 'right'],
    'actuator':  ['solenoid'],

    'steering':   ['stearing', 'streering'],
    'stearing':   ['steering'],
    'streering':  ['steering'],

    'hydraulic':   ['hydrostatic', 'hst'],
    'hydrostatic': ['hydraulic', 'hst'],
    'hst':         ['hydraulic', 'hydrostatic'],
    'hydrolic':    ['hydraulic'],
    'hydralic':    ['hydraulic'],
    'hydrologic':  ['hydraulic'],
    'hydronic':    ['hydraulic'],

    'vavle':    ['valve'],
    'axel':     ['axle'],
    'frount':   ['front'],
    'selenoid': ['solenoid'],
    'shuttel':  ['shuttle'],

    'ujoint':      ['u-joint', 'u joint'],
    'bellymower':  ['belly mower'],

    'tach':     ['tachometer', 'rpm'],
    
    // --- Hydraulic misspellings / partials ---
    'hyd':       ['hydraulic'],
    'hydrol':    ['hydraulic'],
    'hydroli':   ['hydraulic'],
    'hydral':    ['hydraulic'],
    'hydru':     ['hydraulic'],
    'hydrualic': ['hydraulic'],

    // --- 3 point ---
    '3pt':         ['3 point', '3-point', 'three point'],
    '3point':      ['3 point', '3-point', 'three point'],
    '3 pt':        ['3 point', '3-point'],
    '3 point':     ['3-point', '3pt', 'three point'],
    'three point': ['3 point', '3-point'],
    'three':       ['3 point', '3-point'],

    // --- Electrical ---
    'ecm':        ['ecu', 'engine control module', 'engine control unit', 'control unit', 'controller'],
    'ecu':        ['ecm', 'engine control module', 'engine control unit', 'control unit'],
    'alternator': ['alt', 'generator', 'dynamo'],
    'altenator':  ['alternator'],
    'altinator':  ['alternator'],
    'alternater': ['alternator'],
    'altenater':  ['alternator'],
    'blinker':    ['turn signal', 'turn lamp', 'turn light', 'indicator', 'flasher', 'hazard', 'signal lamp', 'signal light', 'lamp', 'light'],
    'turn signal':['blinker', 'indicator', 'flasher', 'turn lamp', 'signal lamp'],
    'flasher':    ['turn signal', 'blinker', 'hazard', 'indicator'],
    'signal':     ['turn signal', 'blinker', 'indicator', 'flasher'],
    'antenna':    ['aerial', 'radio', 'mast'],
    'rpm':        ['tachometer', 'tach', 'speed sensor', 'engine speed'],
    'ign':        ['ignition'],
    'temp':       ['temperature'],

    // --- Engine / cooling ---
    'waterpump':  ['water pump', 'coolant pump'],
    'water pump': ['waterpump', 'coolant pump'],
    'ccv':        ['crankcase ventilation', 'crankcase breather', 'breather', 'pcv', 'blow-by', 'blowby'],
    'pcv':        ['ccv', 'crankcase ventilation', 'breather'],
    'egr':        ['exhaust gas recirculation'],
    'dpf':        ['diesel particulate filter'],
    'def':        ['diesel exhaust fluid', 'adblue', 'urea'],
    'doc':        ['diesel oxidation catalyst'],
    'carb':       ['carburetor', 'carburettor'],
    'eng':        ['engine'],
    'cyl':        ['cylinder'],

    // --- Steering / drivetrain ---
    'tierod':     ['tie rod', 'tie-rod'],
    'tie-rod':    ['tie rod', 'tierod'],
    'tie rod':    ['tie-rod', 'tierod', 'rod end', 'drag link'],
    'trans':      ['transmission'],
    'tranny':     ['transmission'],
    'diff':       ['differential'],
    'mfwd':       ['4wd', 'front axle', 'front wheel drive'],
    '4wd':        ['4x4', 'mfwd', 'four wheel drive', 'front axle'],
    '4x4':        ['4wd', 'mfwd', 'four wheel drive'],
    'pto':        ['power take off', 'power take-off'],
    'power take off': ['pto'],
    'detent':     ['detent ball', 'check ball', 'steel ball', 'plunger', 'spool', 'control valve'],

    // --- Loader / implements ---
    'fel':        ['front end loader', 'front loader', 'loader'],
    'front end loader': ['fel', 'loader', 'front loader'],
    'loader':     ['fel', 'front end loader'],
    'receiver':   ['hitch', 'receiver hitch', 'hitch receiver', 'drawbar'],
    'brush hog':  ['bush hog', 'brushhog', 'rotary cutter', 'rotary mower'],
    'bush hog':   ['brush hog', 'rotary cutter', 'rotary mower'],
    'snowblower': ['snow blower', 'snow thrower', 'snowthrower'],
    'snow plow':  ['snow blade', 'plow', 'blade'],

    // --- Cab / body ---
    'canopy':     ['sunshade', 'sun shade', 'umbrella', 'roof', 'cab roof', 'top'],
    'canop':      ['canopy', 'sunshade', 'roof'],
    'sunroof':    ['roof window', 'roof glass', 'top window', 'roof hatch', 'hatch', 'roof panel', 'skylight'],
    'cowl':       ['hood', 'bonnet', 'dash', 'dashboard', 'panel', 'shroud', 'cover'],
    'rops':       ['roll bar', 'rollbar', 'rollover', 'roll over'],
    'roll bar':   ['rops', 'rollbar'],
    'rollbar':    ['rops', 'roll bar'],
    'toolbox':    ['tool box', 'storage box'],

    // --- Common abbreviations in part titles ---
    'assy':       ['assembly'],
    'assembly':   ['assy'],
    'brg':        ['bearing'],
    'lh':         ['left', 'left hand', 'driver side'],
    'rh':         ['right', 'right hand', 'passenger side'],
  };

  // --- STEMMER ---
  function stem(word) {
    word = word.toLowerCase();
    if (word.length <= 3) return word;
    if (word.endsWith('ies'))  return word.slice(0, -3) + 'y';
    if (word.endsWith('ves'))  return word.slice(0, -3) + 'f';
    if (word.endsWith('sses') || word.endsWith('xes') || word.endsWith('zes') || word.endsWith('ches') || word.endsWith('shes')) {
      return word.slice(0, -2);
    }
    if (word.endsWith('es') && word.length > 4) return word.slice(0, -2);
    if (word.endsWith('ing') && word.length > 5) return word.slice(0, -3);
    if (word.endsWith('er') && word.length > 4)  return word.slice(0, -2);
    if (word.endsWith('s') && !word.endsWith('ss') && word.length > 3) return word.slice(0, -1);
    return word;
  }

  function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // --- SIDEBAR FILTER (TAG) HELPERS ---
  // Avenue's sidebar filters are tag URLs: /collections/7010/category_ac,
  // and stacking a second filter joins them with "+":
  // /collections/7010/category_ac+category_bearing. The tag in the URL is
  // Shopify's handleized form of the tag ("Category_Air Filter" ->
  // "category_air-filter"), so tags are compared in that same form.
  function handleize(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9_]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // Reads the active filter tags from the current URL path. Shopify tag
  // filtering is AND: a product has to carry every active tag.
  function getActiveFilterTags() {
    var path;
    try {
      path = decodeURIComponent(window.location.pathname);
    } catch (e) {
      path = window.location.pathname;
    }
    var prefix = ('/collections/' + collectionHandle + '/').toLowerCase();
    if (path.toLowerCase().indexOf(prefix) !== 0) return [];
    var rest = path.slice(prefix.length).split('/')[0];
    if (!rest) return [];
    return rest.split('+').map(handleize).filter(Boolean);
  }

  function applyActiveFilters(products) {
    var active = getActiveFilterTags();
    if (!active.length) return products;
    return products.filter(function(product) {
      var tags = product.tagHandles || [];
      return active.every(function(t) { return tags.indexOf(t) !== -1; });
    });
  }

  // --- QUERY EXPANDER ---
  // Also precompiles the regexes needed for scoring ONCE per query, instead
  // of once per query PER PRODUCT (previously this ran thousands of times
  // per keystroke).

  // Whole-word matcher. Plain \b fails for phrases that start or end with
  // punctuation ("a/c", "3-point"), so the edges are spelled out instead.
  function wordRegex(phrase) {
    return new RegExp('(^|[^a-z0-9])' + escapeRegex(phrase) + '(?=$|[^a-z0-9])', 'i');
  }

  // Multi-word synonym keys ("drive shaft", "seal kit", "driver side") can't
  // be found by looking the query up one word at a time, so they're checked
  // against the whole query instead.
  var MULTIWORD_KEYS = Object.keys(SYNONYMS).filter(function(k) { return k.indexOf(' ') !== -1; });

  function expandQuery(searchTerm) {
    var normalized = searchTerm.toLowerCase().trim();
    var tokens = normalized.split(/\s+/);
    var exactTerms = new Set();
    var synonymTerms = new Set();

    tokens.forEach(function(token) {
      exactTerms.add(token);
      exactTerms.add(stem(token));
    });

    function addSynonyms(list) {
      (list || []).forEach(function(syn) {
        syn = String(syn).toLowerCase(); // map has 'A/C', 'A C'
        if (!exactTerms.has(syn) && !exactTerms.has(stem(syn))) synonymTerms.add(syn);
      });
    }

    tokens.forEach(function(token) {
      var s = stem(token);
      addSynonyms(SYNONYMS[token]);
      if (s !== token) addSynonyms(SYNONYMS[s]);
    });
    MULTIWORD_KEYS.forEach(function(key) {
      if (wordRegex(key).test(normalized)) addSynonyms(SYNONYMS[key]);
    });

    // Words the shopper typed: 4+ characters match inside words, so "bear"
    // finds "bearing" while they're still typing. 1-3 characters must be a
    // whole word, or "ac" would match "bracket" and "back".
    var exactMatchers = Array.from(exactTerms).map(function(term) {
      if (term.length <= 3) return { re: wordRegex(term) };
      return { sub: term, subStem: stem(term) };
    });

    // Synonyms always match whole words only, so "seal" -> "ring" doesn't
    // pull in bearing/steering/spring and "fuel" -> "gas" doesn't pull in
    // gaskets. The stemmed form is checked against the stemmed text so
    // plurals still match ("rings" -> "ring").
    var synonymMatchers = Array.from(synonymTerms).map(function(syn) {
      var stemmed = syn.split(/\s+/).map(stem).join(' ');
      return { term: syn, re: wordRegex(syn), stemRe: wordRegex(stemmed) };
    });

    var tokenMeta = tokens.map(function(token) {
      var s = stem(token);
      return {
        token: token,
        stemmed: s,
        wordRegex: new RegExp('\\b' + escapeRegex(token) + '\\b', 'i'),
        stemRegex: new RegExp('\\b' + escapeRegex(s) + '\\b', 'i')
      };
    });

    return {
      exactTerms: Array.from(exactTerms),
      synonymTerms: Array.from(synonymTerms),
      exactMatchers: exactMatchers,
      synonymMatchers: synonymMatchers,
      tokens: tokens,
      tokenMeta: tokenMeta,
      normalized: normalized
    };
  }

  // --- SCORER ---
  // Uses fields precomputed once at fetch/cache time (product.titleLower,
  // product.titleStemmed, product.descText) and regexes precompiled once
  // per query (expanded.tokenMeta) instead of rebuilding either per call.
  function scoreProduct(product, expanded) {
    var title = product.titleLower;
    var titleStemmed = product.titleStemmed;
    var description = product.descText;
    var tagText = product.tagText || '';
    var score = 0;

    if (title === expanded.normalized) {
      return 1000;
    }

    if (title.indexOf(expanded.normalized) === 0) {
      score += 500;
    }

    if (title.indexOf(expanded.normalized) !== -1) {
      score += 300;
    }

    for (var i = 0; i < expanded.tokenMeta.length; i++) {
      var meta = expanded.tokenMeta[i];

      if (meta.wordRegex.test(title)) {
        score += 100;
        var pos = title.indexOf(meta.token);
        if (pos !== -1 && pos < 20) score += 50;
      }

      if (meta.stemRegex.test(titleStemmed)) {
        score += 80;
      }

      if (title.indexOf(meta.token) !== -1) {
        score += 40;
      } else if (titleStemmed.indexOf(meta.stemmed) !== -1) {
        score += 30;
      }
      if (description.indexOf(meta.token) !== -1) {
        score += 25;
      }
      if (tagText && tagText.indexOf(meta.token) !== -1) {
        score += 35; // curated Category_/Part_ tag match — more deliberate than a description hit
      }
    }

    for (var j = 0; j < expanded.synonymMatchers.length; j++) {
      var sm = expanded.synonymMatchers[j];
      if (sm.re.test(title) || sm.stemRe.test(titleStemmed)) {
        score += 15;
      }
    }

    var matchedTokenCount = 0;
    for (var k = 0; k < expanded.tokenMeta.length; k++) {
      var m = expanded.tokenMeta[k];
      if (title.indexOf(m.token) !== -1 || titleStemmed.indexOf(m.stemmed) !== -1) {
        matchedTokenCount++;
      }
    }
    score += matchedTokenCount * 20;

    return score;
  }

  // --- PARTS DIAGRAMS ---
  // Diagrams come from the collection's custom.parts_diagrams metafield,
  // rendered by model-collection-search.liquid into window.partsDiagrams.
  // Built lazily on first search so it doesn't matter whether that Liquid
  // <script> sits before or after this file on the page.
  var partsDiagrams = null;

  // Line-drawn diagram used when the snapshot image (window.partsDiagramThumb)
  // isn't set or fails to load, so the card never shows a broken image.
  var DIAGRAM_FALLBACK_SVG =
    '<svg class="diagram-thumb-fallback" viewBox="0 0 150 112" fill="none" stroke="#555" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
      '<rect x="14" y="44" width="70" height="26" rx="4"/>' +
      '<circle cx="104" cy="57" r="16"/><circle cx="104" cy="57" r="6"/>' +
      '<line x1="84" y1="57" x2="88" y2="57"/>' +
      '<rect x="26" y="14" width="22" height="14" rx="2"/>' +
      '<line x1="37" y1="28" x2="37" y2="44" stroke-dasharray="3 3"/>' +
      '<circle cx="130" cy="30" r="7"/>' +
      '<line x1="124" y1="35" x2="114" y2="45" stroke-dasharray="3 3"/>' +
      '<rect x="40" y="86" width="30" height="10" rx="2"/>' +
      '<line x1="55" y1="70" x2="55" y2="86" stroke-dasharray="3 3"/>' +
      '<text x="8" y="12" font-size="9" fill="#990000" stroke="none" font-family="sans-serif" font-weight="700">1</text>' +
      '<text x="136" y="16" font-size="9" fill="#990000" stroke="none" font-family="sans-serif" font-weight="700">2</text>' +
      '<text x="76" y="106" font-size="9" fill="#990000" stroke="none" font-family="sans-serif" font-weight="700">3</text>' +
    '</svg>';

  function normalizePartNumber(str) {
    return String(str || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getDiagrams() {
    if (partsDiagrams) return partsDiagrams;
    partsDiagrams = (window.partsDiagrams || [])
      .filter(function(d) { return d && d.url; })
      .map(function(d) {
        var partNumbers = String(d.partNumbers || '')
          .split(/[\s,;]+/)
          .map(normalizePartNumber)
          .filter(function(n) { return n.length >= 5; });
        var wordText = ((d.name || '') + ' ' + (d.keywords || '')).toLowerCase();
        return {
          name: d.name || 'Parts diagram',
          url: d.url,
          pageUrl: d.pageUrl || '',
          partNumbers: partNumbers,
          wordText: wordText,
          wordStemmed: wordText.split(/[^a-z0-9]+/).map(stem).join(' ')
        };
      });
    return partsDiagrams;
  }

  // A diagram matches when:
  //  1) the query (or any word in it) is a part number on the diagram —
  //     dashes/spaces ignored, and 6+ characters of a number count as a
  //     match so it shows up while the shopper is still typing; or
  //  2) every word of the query appears in the diagram's name/keywords,
  //     directly, stemmed, or through the same SYNONYMS map products use.
  function searchDiagrams(searchTerm) {
    var diagrams = getDiagrams();
    var term = (searchTerm || '').toLowerCase().trim();
    if (!diagrams.length || !term) return [];

    var tokens = term.split(/\s+/).filter(Boolean);
    var partCandidates = [normalizePartNumber(term)]
      .concat(tokens.map(normalizePartNumber))
      .filter(function(c) { return c.length >= 5 && /\d/.test(c); });

    var results = [];

    diagrams.forEach(function(d) {
      var matchedPart = null;
      for (var i = 0; i < partCandidates.length && !matchedPart; i++) {
        var c = partCandidates[i];
        for (var j = 0; j < d.partNumbers.length; j++) {
          var n = d.partNumbers[j];
          if (n === c || (c.length >= 6 && n.indexOf(c) === 0)) {
            matchedPart = n;
            break;
          }
        }
      }
      if (matchedPart) {
        results.push({ diagram: d, matchedPart: matchedPart, score: 2 });
        return;
      }

      var allWordsMatch = tokens.every(function(t) {
        var options = [t, stem(t)]
          .concat(SYNONYMS[t] || [])
          .concat(SYNONYMS[stem(t)] || []);
        return options.some(function(o) {
          o = String(o).toLowerCase();
          return d.wordText.indexOf(o) !== -1 || d.wordStemmed.indexOf(stem(o)) !== -1;
        });
      });
      if (allWordsMatch) {
        results.push({ diagram: d, matchedPart: null, score: 1 });
      }
    });

    results.sort(function(a, b) { return b.score - a.score; });
    return results;
  }

  // --- MODEL-REDUNDANT TOKEN STRIPPING ---
  // A shopper browsing the "4540" collection who searches "4540" (or
  // "4540 grill") isn't giving us any new information with the "4540" —
  // every product on this page already matches that model, since it's in
  // the title/fitment description of all of them. Left as-is, that token
  // alone is enough to match nearly the whole catalog (and OR-style token
  // matching means adding "grill" doesn't narrow it either). So: strip any
  // query word that's redundant with this collection's own identifier
  // before searching, and only search on what's actually left.
  var COLLECTION_TOKENS = (collectionHandle || '')
    .toLowerCase()
    .split(/[-_]+/)
    .filter(Boolean);

  function stripRedundantModelTokens(searchTerm) {
    var rawTokens = searchTerm.toLowerCase().trim().split(/\s+/).filter(Boolean);
    var meaningfulTokens = rawTokens.filter(function(t) {
      return COLLECTION_TOKENS.indexOf(t) === -1;
    });

    return {
      term: meaningfulTokens.join(' '),
      isRedundantOnly: rawTokens.length > 0 && meaningfulTokens.length === 0
    };
  }

  // --- SEARCH ---
  function searchAllProducts(searchTerm) {
    if (!searchTerm.trim()) return [];

    var expanded = expandQuery(searchTerm);

    // searchText already contains the title, and searchStemmed the stemmed
    // title, so those two fields cover everything.
    var matched = allProducts.filter(function(product) {
      var exactHit = expanded.exactMatchers.some(function(m) {
        if (m.re) return m.re.test(product.searchText) || m.re.test(product.searchStemmed);
        return product.searchText.indexOf(m.sub) !== -1 || product.searchStemmed.indexOf(m.subStem) !== -1;
      });
      if (exactHit) return true;
      return expanded.synonymMatchers.some(function(m) {
        return m.re.test(product.searchText) || m.stemRe.test(product.searchStemmed);
      });
    });

    var scored = matched.map(function(product) {
      return {
        product: product,
        score: scoreProduct(product, expanded)
      };
    });

    scored.sort(function(a, b) { return b.score - a.score; });

    return scored.map(function(item) { return item.product; });
  }

  // --- ANALYTICS LOGGING ---
  var lastLoggedTerm = '';

  function logSearchQuery(searchTerm, resultsCount, searchId) {
    if (!ANALYTICS_WEBHOOK_URL) return;

    clearTimeout(analyticsTimeout);

    analyticsTimeout = setTimeout(function() {
      var term = (searchTerm || '').trim();

      if (term.length < 3) return;
      if (term === lastLoggedTerm) return;

      lastLoggedTerm = term;

      fetch(ANALYTICS_WEBHOOK_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          searchTerm: term,
          resultsCount: resultsCount,
          collection: collectionHandle,
          page: window.location.href,
          searchId: searchId
        })
      }).catch(function(error) {
        console.error('Error logging search:', error);
      });
    }, 800);
  }

  function sendAnalytics(payload) {
    // View/title/image clicks navigate away immediately, which can abort a
    // fetch() before it finishes sending. sendBeacon is designed for exactly
    // this — it's handed off to the browser to deliver even through
    // navigation/unload. Fall back to fetch only if sendBeacon isn't
    // available (very old browsers).
    if (navigator.sendBeacon) {
      var blob = new Blob([payload], { type: 'text/plain' });
      navigator.sendBeacon(ANALYTICS_WEBHOOK_URL, blob);
    } else {
      fetch(ANALYTICS_WEBHOOK_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain' },
        body: payload
      }).catch(function(error) {
        console.error('Error logging click:', error);
      });
    }
  }

  function logProductClick(product, action, position) {
    if (!ANALYTICS_WEBHOOK_URL) return;

    sendAnalytics(JSON.stringify({
      eventType: 'product_click',
      searchTerm: currentSearchTerm,
      searchId: currentSearchId,
      productTitle: product.title,
      productHandle: product.handle,
      productUrl: '/products/' + product.handle,
      action: action,           // 'view', 'add_to_cart', or 'title_link'
      position: position,       // 0-based rank in the result list
      collection: collectionHandle,
      page: window.location.href
    }));
  }

  // Diagram opens are logged as the same event type as product clicks, so
  // they land in the matching search row without any Apps Script changes —
  // action 'diagram' and a 'diagram:' handle tell them apart in the sheet.
  function logDiagramClick(name, url, position) {
    if (!ANALYTICS_WEBHOOK_URL) return;

    sendAnalytics(JSON.stringify({
      eventType: 'product_click',
      searchTerm: currentSearchTerm,
      searchId: currentSearchId,
      productTitle: name,
      productHandle: 'diagram:' + name,
      productUrl: url,
      action: 'diagram',
      position: position,
      collection: collectionHandle,
      page: window.location.href
    }));
  }

  // --- IN-BAR LOADING FILL STYLES ---
  // The fill is its own element laid over the inside of the search bar,
  // so theme styles on the input's background can't hide it. It uses a
  // "multiply" blend: white turns light green, while the dark typed text
  // stays dark and readable. pointer-events:none means clicks and typing
  // pass straight through to the input.
  function injectLoadingStyles() {
    if (document.getElementById('cs-fill-styles')) return;
    var css =
      '#cs-fill{position:absolute;pointer-events:none;overflow:hidden;z-index:2;' +
        'mix-blend-mode:multiply;opacity:0;transition:opacity .25s ease;display:none}' +
      '#cs-fill.is-visible{opacity:1}' +
      '#cs-fill .cs-fill-bar{position:absolute;top:0;left:0;height:100%;width:5%;' +
        'background:rgba(30,142,78,.22);transition:width .35s ease}' +
      '#cs-fill.is-indeterminate .cs-fill-bar{width:35%;animation:csFillSlide 1.2s ease-in-out infinite}' +
      '@keyframes csFillSlide{0%{left:-35%}100%{left:100%}}' +
      '@media (prefers-reduced-motion:reduce){#cs-fill .cs-fill-bar{transition:none}' +
        '#cs-fill.is-indeterminate .cs-fill-bar{animation-duration:3s}}';

    var style = document.createElement('style');
    style.id = 'cs-fill-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  // Hides sidebar filter options that have no matches in the search results.
  function injectFilterStyles() {
    if (document.getElementById('cs-filter-styles')) return;
    var style = document.createElement('style');
    style.id = 'cs-filter-styles';
    style.textContent = '#filters .cs-filter-hidden{display:none !important}';
    document.head.appendChild(style);
  }

  // --- DOM READY ---
  document.addEventListener('DOMContentLoaded', function() {
    var searchInput = document.getElementById('collection-search');
    var clearButton = document.getElementById('clear-search');
    var searchIcon = document.getElementById('search-icon');
    var loadingIndicator = document.getElementById('search-loading');
    var resultsCount = document.getElementById('search-results-count');
    var searchContainer = document.getElementById('search-results-container');
    var searchGrid = document.getElementById('search-results-grid');
    var loadMoreBtn = document.getElementById('load-more-btn');
    var endSeparator = document.getElementById('search-end-separator');
    var searchTimeout;

    // Only run where the collection search widget is on the page. Without
    // this, any page that loads the script but lacks the markup throws.
    if (!searchInput || !searchGrid || !searchContainer || !resultsCount ||
        !clearButton || !loadMoreBtn || !endSeparator) {
      return;
    }

    // The theme REPLACES #collection-products (with a new element) every
    // time a sidebar filter is clicked, so it's always looked up fresh
    // instead of kept in a variable that would point at the old one.
    function getOriginalGrid() {
      return document.getElementById('collection-products');
    }

    injectFilterStyles();

    // --- IN-BAR LOADING FILL ---
    // While the catalog downloads, a soft green fill sweeps across the
    // inside of the search bar. The only visible text is what the shopper
    // typed; the existing spinner (#search-loading) stays next to the clear
    // button. Only used for a network load — cached loads are instant.
    var fillEl = null;
    var fillBar = null;
    var fillBordered = null; // the element that draws the green border
    var fillHost = null;     // the element the fill is placed inside
    var fillActive = false;
    var fillHideTimer = null;

    // Walk up from the input to find whichever element actually draws the
    // visible border (the input itself or one of its wrappers).
    function findBorderedElement() {
      var el = searchInput;
      for (var i = 0; i < 4 && el && el !== document.body; i++) {
        var cs = getComputedStyle(el);
        if (parseFloat(cs.borderTopWidth) >= 1 && cs.borderTopStyle !== 'none') return el;
        el = el.parentElement;
      }
      return searchInput;
    }

    function buildFill() {
      if (fillEl) return fillEl;
      if (!searchInput) return null;
      injectLoadingStyles();

      fillBordered = findBorderedElement();
      // An <input> can't hold children, so if the input draws the border,
      // the fill goes in its parent and is positioned over the input.
      fillHost = (fillBordered === searchInput) ? searchInput.parentElement : fillBordered;
      if (!fillHost) return null;
      if (getComputedStyle(fillHost).position === 'static') {
        fillHost.style.position = 'relative';
      }

      fillEl = document.createElement('div');
      fillEl.id = 'cs-fill';
      fillEl.setAttribute('aria-hidden', 'true');
      fillEl.innerHTML = '<div class="cs-fill-bar"></div>';
      fillHost.appendChild(fillEl);
      fillBar = fillEl.querySelector('.cs-fill-bar');
      return fillEl;
    }

    // Lines the fill up exactly with the inside of the bordered box
    // (inside the border, matching its rounded corners).
    function positionFill() {
      if (!fillEl) return;
      var b = fillBordered.getBoundingClientRect();
      var h = fillHost.getBoundingClientRect();
      var cs = getComputedStyle(fillBordered);
      var borderW = parseFloat(cs.borderTopWidth) || 0;
      var radius = Math.max(0, (parseFloat(cs.borderTopLeftRadius) || 0) - borderW);

      fillEl.style.left = (b.left + fillBordered.clientLeft - h.left - fillHost.clientLeft) + 'px';
      fillEl.style.top = (b.top + fillBordered.clientTop - h.top - fillHost.clientTop) + 'px';
      fillEl.style.width = fillBordered.clientWidth + 'px';
      fillEl.style.height = fillBordered.clientHeight + 'px';
      fillEl.style.borderRadius = radius + 'px';
    }

    function showLoadingFill() {
      if (!buildFill()) return;
      clearTimeout(fillHideTimer);

      if (TOTAL_PRODUCT_COUNT) {
        fillEl.classList.remove('is-indeterminate');
        fillBar.style.width = '5%';
      } else {
        fillEl.classList.add('is-indeterminate');
        fillBar.style.width = '';
      }

      fillEl.style.display = 'block';
      positionFill();
      // Next frame so the opacity fade-in actually animates.
      requestAnimationFrame(function() { fillEl.classList.add('is-visible'); });

      searchInput.setAttribute('aria-busy', 'true');
      window.addEventListener('resize', positionFill);
      fillActive = true;
    }

    function updateLoadingProgress(loadedCount) {
      if (!fillActive || !TOTAL_PRODUCT_COUNT) return;
      var pct = Math.max(5, Math.min(95, (loadedCount / TOTAL_PRODUCT_COUNT) * 100));
      fillBar.style.width = pct + '%';
    }

    function hideLoadingFill() {
      if (!fillActive) return;
      fillActive = false;
      searchInput.removeAttribute('aria-busy');
      window.removeEventListener('resize', positionFill);

      // Let the fill visibly reach the end, then fade it out.
      if (TOTAL_PRODUCT_COUNT) fillBar.style.width = '100%';
      fillHideTimer = setTimeout(function() {
        fillEl.classList.remove('is-visible');
        fillHideTimer = setTimeout(function() {
          fillEl.style.display = 'none';
          fillEl.classList.remove('is-indeterminate');
        }, 250);
      }, TOTAL_PRODUCT_COUNT ? 350 : 0);
    }

    // Keeps the results line's height during loading so the page doesn't
    // jump, without showing any loading text there.
    var BLANK_LINE = '\u00a0';

    // --- SIDEBAR FILTER OPTIONS ---
    // Works out which tag a sidebar option adds. The theme puts the raw tag
    // in the link title ("Narrow selection to products matching tag
    // Category_Bearing"); if that's ever missing, fall back to the one tag
    // in the link's URL that isn't already active.
    function getOptionTag(li) {
      var a = li.querySelector('a');
      if (!a) return null;

      var m = (a.getAttribute('title') || '').match(/matching tag\s+(.+)$/i);
      if (m) return handleize(m[1]);

      var href = a.getAttribute('href') || '';
      var prefix = ('/collections/' + collectionHandle + '/').toLowerCase();
      var path;
      try { path = decodeURIComponent(href.split('?')[0]); } catch (e) { path = href.split('?')[0]; }
      if (path.toLowerCase().indexOf(prefix) !== 0) return null;
      var active = getActiveFilterTags();
      var added = path.slice(prefix.length).split('/')[0].split('+').map(handleize).filter(function(t) {
        return t && active.indexOf(t) === -1;
      });
      return added.length === 1 ? added[0] : null;
    }

    // Hides every sidebar option that wouldn't match any of the current
    // search results, and any filter group left with nothing to click.
    // Active filters always stay visible so they can be removed.
    function updateSidebarFilters(products) {
      var filtersEl = document.getElementById('filters');
      if (!filtersEl) return;

      var counts = {};
      products.forEach(function(p) {
        (p.tagHandles || []).forEach(function(t) {
          counts[t] = (counts[t] || 0) + 1;
        });
      });

      filtersEl.querySelectorAll('li.advanced-filter').forEach(function(li) {
        if (li.classList.contains('active-filter')) {
          li.classList.remove('cs-filter-hidden');
          return;
        }
        var tag = getOptionTag(li);
        if (!tag) return; // unknown option — leave it alone
        li.classList.toggle('cs-filter-hidden', !counts[tag]);
      });

      filtersEl.querySelectorAll('.filter').forEach(function(block) {
        var options = block.querySelectorAll('li.advanced-filter');
        if (!options.length) return;
        var anyVisible = Array.prototype.some.call(options, function(o) {
          return !o.classList.contains('cs-filter-hidden');
        });
        block.classList.toggle('cs-filter-hidden', !anyVisible);
      });
    }

    function restoreSidebarFilters() {
      var filtersEl = document.getElementById('filters');
      if (!filtersEl) return;
      filtersEl.querySelectorAll('.cs-filter-hidden').forEach(function(el) {
        el.classList.remove('cs-filter-hidden');
      });
    }

    // Diagram cards sit directly above the product results. The container
    // is created here rather than in the Liquid so no markup change is needed.
    var diagramResults = document.getElementById('diagram-results');
    if (!diagramResults && searchGrid && searchGrid.parentNode) {
      diagramResults = document.createElement('div');
      diagramResults.id = 'diagram-results';
      diagramResults.style.display = 'none';
      searchGrid.parentNode.insertBefore(diagramResults, searchGrid);
    }

    function renderDiagrams(matches) {
      if (!diagramResults) return;
      if (!matches || matches.length === 0) {
        diagramResults.innerHTML = '';
        diagramResults.style.display = 'none';
        return;
      }

      var thumbUrl = window.partsDiagramThumb || '';
      var html = '';
      matches.forEach(function(m, i) {
        var d = m.diagram;
        var sub = m.matchedPart
          ? 'Part ' + escapeHtml(m.matchedPart) + ' is on this diagram — see where it fits and buy related parts'
          : 'Exploded view with part numbers and buy links';
        // Open the diagram's own page (/pages/parts-diagrams/<handle>), which has
        // the viewer plus the parts tables. Falls back to the plain viewer page
        // if an entry has no web page.
        var viewerUrl = d.pageUrl || ('/pages/parts-diagram?file=' + encodeURIComponent(d.url));
        html += '<a class="diagram-card" href="' + escapeHtml(viewerUrl) + '" target="_blank" rel="noopener"' +
                ' data-diagram-name="' + escapeHtml(d.name) + '" data-position="' + i + '">';
        html += '<span class="diagram-thumb' + (thumbUrl ? '' : ' is-fallback') + '" aria-hidden="true">';
        if (thumbUrl) {
          html += '<img src="' + escapeHtml(thumbUrl) + '" alt="" loading="lazy"' +
                  ' onerror="this.parentNode.classList.add(\'is-fallback\');this.remove();">';
        }
        html += DIAGRAM_FALLBACK_SVG;
        html += '</span>';
        html += '<span class="diagram-text">';
        html += '<span class="diagram-name">' + escapeHtml(d.name) + '</span>';
        html += '<span class="diagram-sub">' + sub + '</span>';
        html += '</span>';
        html += '<span class="diagram-cta">View Diagram</span>';
        html += '</a>';
      });

      diagramResults.innerHTML = html;
      diagramResults.style.display = 'block';
    }

    if (diagramResults) {
      diagramResults.addEventListener('click', function(e) {
        var card = e.target.closest('.diagram-card');
        if (!card) return;
        logDiagramClick(
          card.getAttribute('data-diagram-name'),
          card.getAttribute('href'),
          parseInt(card.getAttribute('data-position'), 10)
        );
      });
    }

    window.addToCartFromSearch = function(variantId, button) {
      var originalText = button.textContent;
      button.textContent = 'Adding...';
      button.disabled = true;

      function resetButton(delay) {
        setTimeout(function() {
          button.textContent = originalText;
          button.style.background = '';
          button.removeAttribute('title');
          button.disabled = false;
        }, delay);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: { 'Model': collectionModel }
        })
      })
      .then(function(response) {
        // Shopify answers a refused add (sold out, over inventory) with
        // HTTP 422 and a JSON body { status, message, description }.
        // That body still parses, so check response.ok before trusting it.
        return response.json().catch(function() { return {}; }).then(function(data) {
          if (!response.ok) {
            var err = new Error(data.description || data.message || ('HTTP ' + response.status));
            err.status = response.status;
            throw err;
          }
          return data;
        });
      })
      .then(function(data) {
        button.textContent = 'Added ✓';
        button.style.background = '#51cf66';
        updateAvenueCart();
        resetButton(2000);
      })
      .catch(function(error) {
        console.error('Error adding to cart:', error);
        button.textContent = error.status === 422 ? 'Not available' : 'Error – try again';
        button.title = error.message;
        button.style.background = '#ff6b6b';
        resetButton(3500);
      });
    };

    function updateAvenueCart() {
      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          document.querySelectorAll('.cartCountSelector').forEach(function(el) {
            el.textContent = cart.item_count;
          });
          var cartTotal = (cart.total_price / 100).toFixed(2);
          document.querySelectorAll('.cartTotalSelector').forEach(function(el) {
            el.textContent = '$' + cartTotal;
          });
        })
        .catch(function(error) { console.error('Error updating cart:', error); });
    }

    // Strips HTML/lowercases/stems ONCE per product, at fetch (or cache-load)
    // time. Every field the scorer and matcher need lives on the product
    // object itself so search-time work is just string.indexOf / regex.test
    // against already-prepared strings — no recomputation per keystroke.
    function precomputeProductFields(product) {
      var descStripped = (product.body_html || "")
        .replace(/<[^>]+>/g, " ")
        .toLowerCase()
        .slice(0, MAX_DESC_CHARS);

      var titleLower = product.title.toLowerCase();
      var titleWords = titleLower.split(/\s+/);
      var titleStemmed = titleWords.map(stem).join(' ');

      // Shopify's Ajax products.json returns tags as a comma-separated
      // string (or occasionally an array, depending on endpoint) — handle
      // both. Only Category_/Part_ tags are curated fitment data worth
      // searching; other tags (shipping, availability, etc.) are noise here.
      var tagsRaw = product.tags || '';
      var tagsArray = Array.isArray(tagsRaw)
        ? tagsRaw
        : tagsRaw.split(',').map(function(t) { return t.trim(); });
      var relevantTags = tagsArray.filter(function(t) {
        return /^(category|part)_/i.test(t);
      });
      var tagText = relevantTags
        .join(' ')
        .toLowerCase()
        .replace(/^(category|part)_/gi, '') // drop the prefix itself, keep the value
        .replace(/_/g, ' ');

      // Every grouped tag (Category_, Part_, Fluid_, ...) in the same
      // handleized form the sidebar filter URLs use, so filter matching is
      // a straight string comparison.
      var tagHandles = tagsArray
        .filter(function(t) { return t && t.indexOf('_') > 0; })
        .map(handleize);

      var searchText = titleLower + " " + descStripped + " " + tagText;
      var searchStemmed = searchText.split(/\s+/).map(stem).join(' ');

      product.titleLower = titleLower;
      product.titleStemmed = titleStemmed;
      product.descText = descStripped;
      product.tagText = tagText;
      product.tagHandles = tagHandles;
      product.searchText = searchText;
      product.searchStemmed = searchStemmed;

      return product;
    }

    // Strip out fields we don't need for search/display to keep the
    // sessionStorage payload as small as possible (full body_html is not
    // needed once we've derived descText from it).
    function toCacheEntry(product) {
      return {
        id: product.id,
        handle: product.handle,
        title: product.title,
        variants: product.variants,
        images: product.images,
        titleLower: product.titleLower,
        titleStemmed: product.titleStemmed,
        descText: product.descText,
        tagText: product.tagText,
        tagHandles: product.tagHandles,
        searchText: product.searchText,
        searchStemmed: product.searchStemmed
      };
    }

    function readCache() {
      try {
        var raw = sessionStorage.getItem(CACHE_KEY);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (!parsed || !parsed.timestamp || !parsed.products) return null;
        if (Date.now() - parsed.timestamp > CACHE_TTL_MS) return null;
        return parsed.products;
      } catch (e) {
        return null;
      }
    }

    function writeCache(products) {
      try {
        var payload = JSON.stringify({
          timestamp: Date.now(),
          products: products.map(toCacheEntry)
        });
        sessionStorage.setItem(CACHE_KEY, payload);
      } catch (e) {
        // Quota exceeded or storage unavailable — fine, we just skip caching
        // and fetch fresh next time instead of breaking search.
        console.warn('Could not cache product search data:', e);
      }
    }

    // Fetches every page of the collection. First page is fetched alone so
    // we know whether there's more than one page; if so, remaining pages
    // are requested in parallel batches instead of one-at-a-time, which is
    // the main win as the catalog grows into many pages. onProgress (if
    // given) is called with the running product count after each step so
    // the in-bar fill can show progress.
    function fetchAllProductsFromNetwork(onProgress) {
      var PAGE_SIZE = 250;
      var BATCH_SIZE = 5; // concurrent page requests per batch

      function reportProgress(count) {
        if (typeof onProgress === 'function') onProgress(count);
      }

      function fetchPage(page) {
        return fetch('/collections/' + collectionHandle + '/products.json?limit=' + PAGE_SIZE + '&page=' + page)
          .then(function(response) {
            if (!response.ok) throw new Error('HTTP error! status: ' + response.status);
            return response.json();
          })
          .then(function(data) {
            return (data && data.products) ? data.products : [];
          });
      }

      return fetchPage(1).then(function(firstPage) {
        var all = firstPage.slice();
        reportProgress(all.length);
        if (firstPage.length < PAGE_SIZE) {
          return all; // only one page, we're done
        }

        // Keep fetching batches of pages in parallel until a batch comes
        // back with any page shorter than PAGE_SIZE (i.e. the last page).
        function fetchNextBatch(startPage) {
          var pageNumbers = [];
          for (var i = 0; i < BATCH_SIZE; i++) pageNumbers.push(startPage + i);

          return Promise.all(pageNumbers.map(fetchPage)).then(function(results) {
            var reachedEnd = false;
            results.forEach(function(pageProducts) {
              all = all.concat(pageProducts);
              if (pageProducts.length < PAGE_SIZE) reachedEnd = true;
            });
            reportProgress(all.length);
            if (reachedEnd) return all;
            return fetchNextBatch(startPage + BATCH_SIZE);
          });
        }

        return fetchNextBatch(2);
      });
    }

    // One shared in-flight load. Without this, every keystroke during the
    // first load kicked off ANOTHER full catalog download, which made the
    // wait longer the more the shopper typed.
    var fetchPromise = null;

    function fetchAllProducts() {
      if (allProducts.length > 0) return Promise.resolve(allProducts);
      if (fetchPromise) return fetchPromise;

      var cached = readCache();
      if (cached && cached.length > 0) {
        allProducts = cached;
        if (loadingIndicator) loadingIndicator.style.display = 'none';
        console.log('Loaded ' + allProducts.length + ' products from cache');
        return Promise.resolve(allProducts);
      }

      if (loadingIndicator) loadingIndicator.style.display = 'block';
      showLoadingFill();

      fetchPromise = fetchAllProductsFromNetwork(updateLoadingProgress)
        .then(function(products) {
          allProducts = products.map(precomputeProductFields);
          writeCache(allProducts);
          if (loadingIndicator) loadingIndicator.style.display = 'none';
          hideLoadingFill();
          fetchPromise = null;
          console.log('Loaded ' + allProducts.length + ' products from network');
          return allProducts;
        })
        .catch(function(error) {
          console.error('Error fetching products:', error);
          if (loadingIndicator) loadingIndicator.style.display = 'none';
          hideLoadingFill();
          fetchPromise = null; // allow a retry on the next keystroke
          resultsCount.textContent = 'Error loading products for search. Please refresh the page and try again.';
          resultsCount.style.color = '#ff6b6b';
          return [];
        });

      return fetchPromise;
    }

    function formatMoney(amount) {
      var num = parseFloat(amount);
      if (isNaN(num)) return '';
      return '$' + num.toFixed(2);
    }

    function createProductCard(product, position) {
      var variant = product.variants[0];
      var imageUrl = product.images[0] ? product.images[0].src : '';
      var isAvailable = variant && variant.available;
      var productUrl = '/products/' + product.handle + '?ref=collections/' + collectionHandle;

      var priceHtml = '';
      if (variant) {
        var price = parseFloat(variant.price);
        var compareAtPrice = variant.compare_at_price ? parseFloat(variant.compare_at_price) : 0;
        var onSale = compareAtPrice > price;

        var prices = product.variants.map(function(v) { return parseFloat(v.price); });
        var minPrice = Math.min.apply(null, prices);
        var maxPrice = Math.max.apply(null, prices);
        var hasRange = minPrice !== maxPrice;

        priceHtml = '<div class="product-price">';
        if (hasRange) {
          priceHtml += '<span class="price-regular">From ' + formatMoney(minPrice) + '</span>';
        } else if (onSale) {
          priceHtml += '<span class="price-compare">' + formatMoney(compareAtPrice) + '</span>';
          priceHtml += '<span class="price-sale">' + formatMoney(price) + '</span>';
        } else {
          priceHtml += '<span class="price-regular">' + formatMoney(price) + '</span>';
        }
        priceHtml += '</div>';
      }

      // Titles often contain inch marks (3/4" Hose), so every value that
      // goes into the HTML is escaped.
      var safeTitle = escapeHtml(product.title);
      var safeHandle = escapeHtml(product.handle);
      var safeUrl = escapeHtml(productUrl);

      var card = '<div class="search-product-card" data-product-handle="' + safeHandle + '" data-position="' + position + '">';
      card += '<div class="product-image-wrapper">';
      card += '<a href="' + safeUrl + '" class="product-link" data-click-action="product_link">';
      card += imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + safeTitle + '" class="product-image" loading="lazy">' : '<div class="no-image">No Image</div>';
      card += '</a>';
      card += !isAvailable ? '<div class="sold-out-badge">Sold Out</div>' : '';
      card += '</div>';
      card += '<div class="product-info">';
      card += '<h3 class="product-title"><a href="' + safeUrl + '" data-click-action="title_link">' + safeTitle + '</a></h3>';
      card += priceHtml;
      card += '<div class="product-actions">';
      if (isAvailable) {
        card += '<button onclick="window.location.href=\'' + safeUrl + '\'" class="btn-view-product" data-click-action="view">View</button>';
        card += '<button onclick="addToCartFromSearch(' + variant.id + ', this)" class="btn-add-to-cart" data-click-action="add_to_cart">Add to Cart</button>';
      } else {
        card += '<button class="btn-sold-out" disabled>Sold Out</button>';
      }
      card += '</div></div></div>';
      return card;
    }

    function displaySearchResults(products, append) {
      if (!append) {
        searchGrid.innerHTML = '';
        displayedResults = 0;
        endSeparator.style.display = 'none';
      }

      var startIndex = displayedResults;
      var endIndex = Math.min(startIndex + resultsPerPage, products.length);

      // Build the batch as one string and set innerHTML once instead of
      // appending in a loop, which avoids repeated reparsing of a growing
      // HTML string.
      var html = '';
      for (var i = startIndex; i < endIndex; i++) {
        html += createProductCard(products[i], i);
      }
      searchGrid.insertAdjacentHTML('beforeend', html);

      displayedResults = endIndex;

      if (displayedResults < products.length) {
        loadMoreBtn.style.display = 'block';
        loadMoreBtn.textContent = 'Load More (' + (products.length - displayedResults) + ' remaining)';
        endSeparator.style.display = 'none';
      } else {
        loadMoreBtn.style.display = 'none';
        if (products.length > 0) endSeparator.style.display = 'block';
      }
    }

    // True while a search is waiting on the first catalog load, so we only
    // queue one "run the search when loading finishes" callback no matter
    // how many keystrokes happen during the load.
    var searchQueuedForLoad = false;

    function performSearch(query) {
      var searchTerm = query.trim();

      if (!searchTerm) {
        searchContainer.style.display = 'none';
        var grid = getOriginalGrid();
        if (grid) grid.style.display = '';
        restoreSidebarFilters();
        renderDiagrams([]);
        resultsCount.textContent = 'Use Keywords/Part# - Grill, Filter, Bearing, etc.';
        resultsCount.style.color = '';
        clearButton.style.display = 'none';
        endSeparator.style.display = 'none';
        return;
      }

      if (allProducts.length === 0) {
        // Loading is shown by the fill inside the search bar — no text here.
        resultsCount.textContent = BLANK_LINE;
        resultsCount.style.color = '';
        clearButton.style.display = 'block';

        if (!searchQueuedForLoad) {
          searchQueuedForLoad = true;
          fetchAllProducts().then(function() {
            searchQueuedForLoad = false;
            // Use whatever is in the box NOW — the shopper may have kept
            // typing (or cleared it) while the catalog was loading.
            var latest = searchInput.value.trim();
            if (!allProducts.length) return; // load failed; error message already shown
            if (latest) {
              performSearchNow(latest);
            } else {
              performSearch('');
            }
          });
        }
      } else {
        performSearchNow(searchTerm);
      }
    }

    // skipLog: true when re-running the same search because a sidebar
    // filter changed, so the analytics sheet doesn't get a duplicate row.
    function performSearchNow(searchTerm, skipLog) {
      currentSearchTerm = searchTerm;
      currentSearchId = Date.now() + '-' + Math.random().toString(36).slice(2, 8);

      var refined = stripRedundantModelTokens(searchTerm);
      var hasActiveFilters = getActiveFilterTags().length > 0;
      var filterNote = hasActiveFilters ? ' in the selected filters' : '';

      var grid = getOriginalGrid();
      if (grid) grid.style.display = 'none';
      searchContainer.style.display = 'block';
      resultsCount.style.color = '';

      if (refined.isRedundantOnly) {
        // Every word in the query is already implied by this collection's
        // own model — searching wouldn't narrow anything further, so don't
        // pretend to filter. Show the full collection (within any selected
        // sidebar filters) and say why.
        renderDiagrams([]);
        filteredProducts = applyActiveFilters(allProducts.slice());
        displaySearchResults(filteredProducts);
        resultsCount.textContent = 'You\'re already viewing all parts for this model — try adding a part name (e.g. "grill", "seal") to narrow it down.';
      } else {
        filteredProducts = applyActiveFilters(searchAllProducts(refined.term));
        var diagramMatches = searchDiagrams(refined.term);
        renderDiagrams(diagramMatches);

        var diagramNote = diagramMatches.length
          ? ' and ' + diagramMatches.length + ' parts diagram' + (diagramMatches.length === 1 ? '' : 's')
          : '';

        if (filteredProducts.length === 0 && diagramMatches.length > 0) {
          // No product listing, but a diagram matched — the diagram is the
          // useful answer, so don't show the "no results" box. Only say the
          // part is "on this diagram" when the search actually matched one of
          // the diagram's part numbers; a word match (e.g. "diagram", "axle")
          // just points to the diagram.
          searchGrid.innerHTML = '';
          var partOnDiagram = diagramMatches.some(function(m) { return m.matchedPart; });
          var diagramWord = diagramMatches.length === 1 ? 'this parts diagram' : 'these parts diagrams';
          resultsCount.textContent = partOnDiagram
            ? 'No product listing for "' + searchTerm + '"' + filterNote + ', but it\'s on ' + diagramWord + ' — or fill out the parts request'
            : 'No products match "' + searchTerm + '"' + filterNote + ' — see ' + diagramWord + ' below';
          loadMoreBtn.style.display = 'none';
          endSeparator.style.display = 'none';
        } else if (filteredProducts.length === 0 && hasActiveFilters) {
          searchGrid.innerHTML = '<div class="no-results"><h3>No products found</h3><p>Nothing matches "' + escapeHtml(searchTerm) + '" with the selected filters — remove a filter to see more</p></div>';
          resultsCount.textContent = 'No products match "' + searchTerm + '" with the selected filters';
          loadMoreBtn.style.display = 'none';
          endSeparator.style.display = 'none';
        } else if (filteredProducts.length === 0) {
          searchGrid.innerHTML = '<div class="no-results"><h3>No products found</h3><p>Try different search terms or browse all products</p></div>';
          resultsCount.textContent = 'No products found, double check or fill out the parts request';
          loadMoreBtn.style.display = 'none';
          endSeparator.style.display = 'none';
        } else {
          displaySearchResults(filteredProducts);
          resultsCount.textContent = 'Found ' + filteredProducts.length + ' product' + (filteredProducts.length === 1 ? '' : 's') + diagramNote + ' matching "' + searchTerm + '"' + filterNote;
        }
      }

      updateSidebarFilters(filteredProducts);

      clearButton.style.display = 'block';
      if (loadingIndicator) loadingIndicator.style.display = 'none';

      if (skipLog) return;

      clearTimeout(analyticsTimeout);
      // Capture the id now — if another search fires before this debounce
      // fires, currentSearchId will have moved on, but this log entry
      // should still record the id for the search it actually describes.
      var searchIdForThisSearch = currentSearchId;
      analyticsTimeout = setTimeout(function() {
        logSearchQuery(searchTerm, filteredProducts.length, searchIdForThisSearch);
      }, 1200);
    }

    // --- REACT TO SIDEBAR FILTER CLICKS ---
    // When a sidebar filter is clicked, the theme fetches the filtered page,
    // swaps in a NEW #collection-products and #filters, and updates the URL.
    // Watching for the new grid lets the theme keep doing all of that
    // normally; if a search is active, we then re-run it against the new
    // filter tags, hide the new native grid, and trim the new sidebar.
    var lastGrid = getOriginalGrid();
    var gridParent = lastGrid ? lastGrid.parentElement : null;

    if (gridParent && window.MutationObserver) {
      new MutationObserver(function() {
        var current = getOriginalGrid();
        if (!current || current === lastGrid) return;
        lastGrid = current;

        var term = searchInput.value.trim();
        if (!term) return; // no search — the theme's normal filtering applies

        if (allProducts.length) {
          performSearchNow(term, true);
        } else {
          // Catalog still loading — hide the new grid now; the queued
          // search will apply the filters once loading finishes.
          current.style.display = 'none';
          performSearch(term);
        }
      }).observe(gridParent, { childList: true });
    }

    searchInput.addEventListener('input', function() {
      // Start loading the catalog on the first character typed (not on
      // click/focus), right away rather than after the 300ms search delay.
      // fetchAllProducts() shares one in-flight load, so calling it on
      // every keystroke is safe.
      if (allProducts.length === 0 && searchInput.value.trim()) {
        fetchAllProducts();
      }

      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(function() {
        performSearch(searchInput.value);
      }, 300);
    });

    clearButton.addEventListener('click', function() {
      searchInput.value = '';
      performSearch('');
      searchInput.focus();
    });

    searchInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        performSearch(searchInput.value);
      }
    });

    loadMoreBtn.addEventListener('click', function() {
      displaySearchResults(filteredProducts, true);
    });

    // Log which product a shopper clicked on after searching. One listener
    // on the grid (event delegation) instead of one per card, so this stays
    // cheap even with hundreds of rendered results. Fires alongside the
    // existing onclick handlers (view/add to cart) — doesn't change what
    // those buttons do, just also reports the click.
    searchGrid.addEventListener('click', function(e) {
      var actionEl = e.target.closest('[data-click-action]');
      if (!actionEl) return;

      var card = e.target.closest('.search-product-card');
      if (!card) return;

      var handle = card.getAttribute('data-product-handle');
      var position = parseInt(card.getAttribute('data-position'), 10);
      var product = filteredProducts.find(function(p) { return p.handle === handle; });
      if (!product) return;

      logProductClick(product, actionEl.getAttribute('data-click-action'), position);
    });

    // --- AUTO-SEARCH FROM THE SAVED-MODEL BANNER ---
    // The banner (in theme.liquid) redirects here with ?search=term when the
    // person searches from a page that isn't this collection's own page.
    // Only fetch the full catalog eagerly in that case — otherwise nothing
    // loads until the shopper actually types in the box.
    var urlParams = new URLSearchParams(window.location.search);
    var initialSearchTerm = urlParams.get('search');

    if (initialSearchTerm) {
      searchInput.value = initialSearchTerm;
      resultsCount.textContent = BLANK_LINE;
      fetchAllProducts().then(function() {
        if (!allProducts.length) return; // load failed; error message already shown
        performSearch(searchInput.value || initialSearchTerm);
        setTimeout(function() {
          scrollToSearchResults();
        }, 300);
      });
    } else {
      resultsCount.textContent = 'Use Keywords/Part# - Grill, Filter, Bearing, etc.';
    }

    // scrollIntoView's default 'start' alignment puts the target at the very
    // top of the viewport (y=0) — but the model banner is position:fixed
    // and sits on top of that, so results end up landing partly hidden
    // underneath it. Read the banner's actual current height (it can vary
    // by breakpoint or if its text wraps) and offset the scroll by that
    // amount, same way applyBannerOffset() accounts for it elsewhere.
    function scrollToSearchResults() {
      var banner = document.getElementById('model-banner');
      var bannerVisible = banner &&
        banner.style.display !== 'none' &&
        getComputedStyle(banner).display !== 'none';
      var bannerHeight = bannerVisible ? banner.offsetHeight : 0;
      var extraBreathingRoom = 12;

      var targetY = searchContainer.getBoundingClientRect().top +
        window.pageYOffset - bannerHeight - extraBreathingRoom;

      window.scrollTo({ top: Math.max(targetY, 0), behavior: 'smooth' });
    }

    updateAvenueCart();
  });

  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      var cartCountElements = document.querySelectorAll('.cartCountSelector');
      if (cartCountElements.length > 0) {
        fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            cartCountElements.forEach(function(el) { el.textContent = cart.item_count; });
            var cartTotal = (cart.total_price / 100).toFixed(2);
            document.querySelectorAll('.cartTotalSelector').forEach(function(el) { el.textContent = '$' + cartTotal; });
          });
      }
    }
  });

})();